{
  // you tube API works by running a single top level script
  // this top level function must be loaded before iframe_api loads
  // that is why we are specifically injecting it this way instead of a normal enqueue
  //
  // when the top level function is called, we simply emit a custom event
  // this way inividual block.js can have access to this event
  const ytscript = document.createElement('script')
  ytscript.src = "https://www.youtube.com/iframe_api"
  document.querySelector('body').appendChild(ytscript)
  window.onYouTubeIframeAPIReady = () => {
    window.dispatchEvent(new Event("YouTubeApiReady"))
  }

  // vimeo could be done better... but for consistency we will do it the same as yt
  const vimscript = document.createElement('script')
  vimscript.src = "https://player.vimeo.com/api/player.js"
  vimscript.onload = () => window.dispatchEvent(new Event("VimeoApiReady"))
  document.querySelector('body').appendChild(vimscript)
}